import { render, staticRenderFns } from "./OrderTopTitle.vue?vue&type=template&id=44e62d1e&"
import script from "./OrderTopTitle.vue?vue&type=script&lang=ts&"
export * from "./OrderTopTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports